import { Link, useLoaderData } from "react-router-dom";
import Select from "react-select";

import * as API from "../services/antpsicologicos";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAntpsicologicosByID(params.antpsicologicosId);
}

export function AntpsicologicosItem(props) {
  const antpsicologicos = useLoaderData();
  const errorMessage = antpsicologicos.message;

  const antpsicResp = antpsicologicos.meta?.antpsicResp;
  const antpsicFecha = antpsicologicos.meta?.metaFecha;
  const antpsicTipo = antpsicologicos.meta && antpsicologicos.meta.antpsicTipo ? antpsicologicos.meta.antpsicTipo : "";
  const antpsicTratprevRad = antpsicologicos.meta?.antpsicTratprevRad;
  const antpsicTratPrevRep = antpsicologicos.meta?.antpsicTratPrevRep;

  const antpsicAfam = antpsicologicos.meta?.antpsicAfam;
  const antpsicPfamRad = antpsicologicos.meta?.antpsicPfamRad;
  const antpsicPfamEsp = antpsicologicos.meta?.antpsicPfamEsp;
  const antpsicPsocRad = antpsicologicos.meta?.antpsicPsocRad;
  const antpsicPsocEsp = antpsicologicos.meta?.antpsicPsocEsp;
  const antpsicPlegRad = antpsicologicos.meta?.antpsicPlegRad;
  const antpsicPlegEsp = antpsicologicos.meta?.antpsicPlegEsp;
  const antpsicPlabRad = antpsicologicos.meta?.antpsicPlabRad;
  const antpsicPlabEsp = antpsicologicos.meta?.antpsicPlabEsp;
  const antpsicActtrat = antpsicologicos.meta?.antpsicActtrat;
  const antpsicRelinterpfam = antpsicologicos.meta?.antpsicRelinterpfam;
  const antpsicRelinterptrab = antpsicologicos.meta?.antpsicRelinterptrab;
  const antpsicRelinterpoc = antpsicologicos.meta?.antpsicRelinterpoc;
  const antpsicVivadic = antpsicologicos.meta?.antpsicVivadic;
  const antpsicFampsiq = antpsicologicos.meta?.antpsicFampsiq;
  const antpsicRelpadre = antpsicologicos.meta?.antpsicRelpadre;
  const antpsicRelmadre = antpsicologicos.meta?.antpsicRelmadre;
  const antpsicRelherm = antpsicologicos.meta?.antpsicRelherm;
  const antpsicRelpareja = antpsicologicos.meta?.antpsicRelpareja;
  const antpsicRelhij = antpsicologicos.meta?.antpsicRelhij;
  const antpsicConvivact = antpsicologicos.meta?.antpsicConvivact;
  const antpsicEstciv = antpsicologicos.meta?.antpsicEstciv;
  const antpsicManutRad = antpsicologicos.meta?.antpsicManutRad;
  const antpsicManutEsp = antpsicologicos.meta?.antpsicManutEsp;
  const antpsicExptrabaj = antpsicologicos.meta?.antpsicExptrabaj;
  const antpsicTrabaj = antpsicologicos.meta?.antpsicTrabaj;
  const antpsicEstlabact = antpsicologicos.meta?.antpsicEstlabact;
  const antpsicEduc = antpsicologicos.meta?.antpsicEduc;
  const antpsicProfRad = antpsicologicos.meta?.antpsicProfRad;
  const antpsicProfEsp = antpsicologicos.meta?.antpsicProfEsp;
  const antpsicTrafdrogRad = antpsicologicos.meta?.antpsicTrafdrogRad;
  const antpsicTrafdorgEsp = antpsicologicos.meta?.antpsicTrafdorgEsp;
  const antpsicJuicRad = antpsicologicos.meta?.antpsicJuicRad;
  const antpsicJuicEsp = antpsicologicos.meta?.antpsicJuicEsp;
  const antpsicCarcRad = antpsicologicos.meta?.antpsicCarcRad;
  const antpsicCarcEsp = antpsicologicos.meta?.antpsicCarcEsp;
  const antpsicArrestRad = antpsicologicos.meta?.antpsicArrestRad;
  const antpsicArrestEsp = antpsicologicos.meta?.antpsicArrestEsp;
  const antpsicSuicRad = antpsicologicos.meta?.antpsicSuicRad;
  const antpsicSuicEsp = antpsicologicos.meta?.antpsicSuicEsp;
  const antpsicAlucRad = antpsicologicos.meta?.antpsicAlucRad;
  const antpsicAlucEsp = antpsicologicos.meta?.antpsicAlucEsp;
  const antpsicApanRad = antpsicologicos.meta?.antpsicApanRad;
  const antpsicApanEsp = antpsicologicos.meta?.antpsicApanEsp;
  const antpsicConvulRad = antpsicologicos.meta?.antpsicConvulRad;
  const antpsicConvulEsp = antpsicologicos.meta?.antpsicConvulEsp;
  const antpsicPerdconcRad = antpsicologicos.meta?.antpsicPerdconcRad;
  const antpsicPerdconcEsp = antpsicologicos.meta?.antpsicPerdconcEsp;
  const antpsicAmnlacRad = antpsicologicos.meta?.antpsicAmnlacRad;
  const antpsicAmnlacEsp = antpsicologicos.meta?.antpsicAmnlacEsp;
  const antpsicPensparanRad = antpsicologicos.meta?.antpsicPensparanRad;
  const antpsicPensparanEsp = antpsicologicos.meta?.antpsicPensparanEsp;
  const antpsicTratpsicofRad = antpsicologicos.meta?.antpsicTratpsicofRad;
  const antpsicTratpsicofEsp = antpsicologicos.meta?.antpsicTratpsicofEsp;
  const antpsicTratpsiqRad = antpsicologicos.meta?.antpsicTratpsiqRad;
  const antpsicTratpsiqEsp = antpsicologicos.meta?.antpsicTratpsiqEsp;
  const antpsicTerapdist = antpsicologicos.meta?.antpsicTerapdist;
  const antpsicTerapcolabRad = antpsicologicos.meta?.antpsicTerapcolabRad;
  const antpsicAnamnesis = antpsicologicos.meta?.antpsicAnamnesis;
  const antpsicEntfamiliar = antpsicologicos.meta?.antpsicEntfamiliar;

  const antpsicDate = new Date(antpsicologicos.date);
  const diffDate = (Math.abs(new Date() - antpsicDate) / 36e5);

  return (
    <>
      <div id='content'>
        {antpsicologicos.length === 0 ? (
          <div>Cargando...</div>
        ) : (
        errorMessage? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement'>
            <fieldset id='disabledContainer' disabled='disabled'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antpsicResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicResp'
                      required
                      type='text'
                      readOnly
                      value={antpsicResp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicFecha'
                      required
                      type='date'
                      readOnly
                      value={antpsicFecha}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='antpsicTipo'
                        name='antpsicTipo'
                        readOnly
                        value={antpsicTipo}
                      >
                        <option disabled value=''> -- Selecciona una opción --</option>
                        <option value='Valoración'>Valoración</option>
                        <option value='Ingreso'>Ingreso</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Tratamientos previos</h3>
              <div className='antpsicTratPrevRepContainer'>
                <div
                  className='field key'
                  data-key={antpsicTratprevRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿El paciente ha realizado tratamientos previos?
                    </label>
                    <label className='radio' htmlFor='antpsicTratprevRadSi'>
                      <input
                        id='antpsicTratprevRadSi'
                        name='antpsicTratprevRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicTratprevRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicTratprevRadNo'>
                      <input
                        id='antpsicTratprevRadNo'
                        name='antpsicTratprevRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicTratprevRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
                {/* aqui empieza el campo repetido */}

                {antpsicTratPrevRep.map((form, index) => {
                  return (
                    <div className='antpsicTratPrevRepItem lock' key={index}>
                      <div className='grid--2col'>
                        <div className='field'>
                          <label htmlFor='fechaentrada'>Fecha de entrada</label>
                          <div className='control'>
                            <input
                              className='input'
                              name='fechaentrada'
                              type='date'
                              readOnly
                              value={form.fechaentrada}
                            />
                          </div>
                        </div>
                        <div className='field'>
                          <label htmlFor='motivosalida'>Motivo de salida</label>
                          <div className='control'>
                            <input
                              className='input'
                              name='motivosalida'
                              type='text'
                              readOnly
                              value={form.motivosalida}
                            />
                          </div>
                        </div>
                        <div className='field'>
                          <label htmlFor='diaspermanencia'>
                            Tiempo de permanencia (Nº de días)
                          </label>
                          <div className='control'>
                            <input
                              className='input'
                              name='diaspermanencia'
                              type='number'
                              readOnly
                              value={form.diaspermanencia}
                            />
                          </div>
                        </div>

                        <div className='field'>
                          <label htmlFor='diasabstinencia'>
                            Tiempo de abstinencia (Nº de días)
                          </label>
                          <div className='control'>
                            <input
                              className='input'
                              name='diasabstinencia'
                              type='number'
                              readOnly
                              value={form.diasabstinencia}
                            />
                          </div>
                        </div>

                        <div className='field'>
                          <label htmlFor='modalidad'>Modalidad</label>
                          <div className='control'>
                            <Select
                              isMulti
                              name='modalidad'
                              className='basic-multi-select'
                              classNamePrefix='select'
                              placeholder='Seleccionar modalidad'
                              value={form.modalidad}
                              readOnly
                              isDisabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                {/* aqui termina el campo repetido */}
              </div>
              <h3>Situación familiar y social</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antpsicEstciv'>Estado civil</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicEstciv'
                        name='antpsicEstciv'
                        readOnly
                        value={antpsicEstciv}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='soltero'>Soltero</option>
                        <option value='casado'>Casado</option>
                        <option value='separado'>Separado</option>
                        <option value='divorciado'>Divorciado</option>
                        <option value='viudo'>Viudo</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicConvivact'>Convivencia actual</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicConvivact'
                        name='antpsicConvivact'
                        readOnly
                        value={antpsicConvivact}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='solo'>Solo</option>
                        <option value='con-padres'>Con sus padres</option>
                        <option value='con-pareja'>Con su pareja</option>
                        <option value='con-pareja-hijos'>
                          Con su pareja e hijos
                        </option>
                        <option value='sin-hogar'>Sin hogar</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelpadre'>
                    En general ¿las relaciones con tu padre son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelpadre'
                        name='antpsicRelpadre'
                        readOnly
                        value={antpsicRelpadre}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='buenas'>Buenas</option>
                        <option value='regulares'>Regulares</option>
                        <option value='malas'>Malas</option>
                        <option value='no-relacion'>No existe relación</option>
                        <option value='no-existe-fam'>
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelmadre'>
                    En general ¿las relaciones con tu madre son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelmadre'
                        name='antpsicRelmadre'
                        readOnly
                        value={antpsicRelmadre}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='buenas'>Buenas</option>
                        <option value='regulares'>Regulares</option>
                        <option value='malas'>Malas</option>
                        <option value='no-relacion'>No existe relación</option>
                        <option value='no-existe-fam'>
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelherm'>
                    En general ¿las relaciones con tus hermanos son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelherm'
                        name='antpsicRelherm'
                        readOnly
                        value={antpsicRelherm}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='buenas'>Buenas</option>
                        <option value='regulares'>Regulares</option>
                        <option value='malas'>Malas</option>
                        <option value='no-relacion'>No existe relación</option>
                        <option value='no-existe-fam'>
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelpareja'>
                    En general ¿las relaciones con tu pareja son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelpareja'
                        name='antpsicRelpareja'
                        readOnly
                        value={antpsicRelpareja}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='buenas'>Buenas</option>
                        <option value='regulares'>Regulares</option>
                        <option value='malas'>Malas</option>
                        <option value='no-relacion'>No existe relación</option>
                        <option value='no-existe-fam'>
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelhij'>
                    En general ¿las relaciones con tus hijos son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelhij'
                        name='antpsicRelhij'
                        readOnly
                        value={antpsicRelhij}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='buenas'>Buenas</option>
                        <option value='regulares'>Regulares</option>
                        <option value='malas'>Malas</option>
                        <option value='no-relacion'>No existe relación</option>
                        <option value='no-existe-fam'>
                          No existe dicho familiar
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicFampsiq'>
                    ¿Alguno de sus familiares ha tenido problemas psiquiátricos
                    o relacionados con alcohol, drogas y/o juegos que le hayan
                    llevado a tratamiento?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicFampsiq'
                        name='antpsicFampsiq'
                        readOnly
                        value={antpsicFampsiq}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no'>No</option>
                        <option value='si-tox'>Sí, toxicomanía</option>
                        <option value='si-psiq'>Sí, psiquiátricos</option>
                        <option value='no-sabe'>No sabe</option>
                        <option value='si'>Si</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicVivadic'>
                    ¿Vive o ha vivido con alguien que tenga algún tipo de
                    adicción?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicVivadic'
                        name='antpsicVivadic'
                        readOnly
                        value={antpsicVivadic}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no'>No</option>
                        <option value='si-pasad'>Sí, en el pasado</option>
                        <option value='si-act'>Sí, en la actualidad</option>
                        <option value='si'>Si</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelinterpfam'>
                    ¿Sus relaciones interpersonales (Familia) son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelinterpfam'
                        name='antpsicRelinterpfam'
                        readOnly
                        value={antpsicRelinterpfam}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no-exist'>
                          No existe ese grupo de referencia
                        </option>
                        <option value='no-consum'>No consumidores</option>
                        <option value='consum'>Consumidores</option>
                        <option value='ex-cosum'>Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelinterptrab'>
                    ¿Sus relaciones interpersonales (Trabajo) son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelinterptrab'
                        name='antpsicRelinterptrab'
                        readOnly
                        value={antpsicRelinterptrab}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no-exist'>
                          No existe ese grupo de referencia
                        </option>
                        <option value='no-consum'>No consumidores</option>
                        <option value='consum'>Consumidores</option>
                        <option value='ex-cosum'>Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicRelinterpoc'>
                    ¿Sus relaciones interpersonales (Ocio) son…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicRelinterpoc'
                        name='antpsicRelinterpoc'
                        readOnly
                        value={antpsicRelinterpoc}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no-exist'>
                          No existe ese grupo de referencia
                        </option>
                        <option value='no-consum'>No consumidores</option>
                        <option value='consum'>Consumidores</option>
                        <option value='ex-cosum'>Ex-consumidores</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicActtrat'>
                    ¿El actual tratamiento fue decidido por…?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicActtrat'
                        name='antpsicActtrat'
                        readOnly
                        value={antpsicActtrat}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='el-mism'>El mismo</option>
                        <option value='su-fam-orig'>
                          Su familia de origen
                        </option>
                        <option value='su-parej'>Su pareja</option>
                        <option value='sist-jud'>Sistema judicial</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field key' data-key={antpsicPfamRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido preocupaciones o dificultades familiares en los
                      últimos 30 días?
                    </label>
                    <label className='radio' htmlFor='antpsicPfamRadSi'>
                      <input
                        id='antpsicPfamRadSi'
                        name='antpsicPfamRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPfamRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPfamRadNo'>
                      <input
                        id='antpsicPfamRadNo'
                        name='antpsicPfamRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPfamRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPfamEsp'>
                    Especificar dificultades familiares
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPfamEsp'
                      type='text'
                      readOnly
                      value={antpsicPfamEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicPsocRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido preocupaciones o dificultades sociales en los
                      últimos 30 días?
                    </label>
                    <label className='radio' htmlFor='antpsicPsocRadSi'>
                      <input
                        id='antpsicPsocRadSi'
                        name='antpsicPsocRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPsocRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPsocRadNo'>
                      <input
                        id='antpsicPsocRadNo'
                        name='antpsicPsocRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPsocRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPsocEsp'>
                    Especificar dificultades sociales
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPsocEsp'
                      type='text'
                      readOnly
                      value={antpsicPsocEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicPlegRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido preocupaciones o dificultades legales en los
                      últimos 30 días?
                    </label>
                    <label className='radio' htmlFor='antpsicPlegRadSi'>
                      <input
                        id='antpsicPlegRadSi'
                        name='antpsicPlegRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPlegRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPlegRadNo'>
                      <input
                        id='antpsicPlegRadNo'
                        name='antpsicPlegRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPlegRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPlegEsp'>
                    Especificar dificultades legales
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPlegEsp'
                      type='text'
                      readOnly
                      value={antpsicPlegEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicPlabRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha tenido preocupaciones o dificultades laborales en los
                      últimos 30 días?
                    </label>
                    <label className='radio' htmlFor='antpsicPlabRadSi'>
                      <input
                        id='antpsicPlabRadSi'
                        name='antpsicPlabRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPlabRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPlabRadNo'>
                      <input
                        id='antpsicPlabRadNo'
                        name='antpsicPlabRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPlabRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPlabEsp'>
                    Especificar dificultades laborales
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPlabEsp'
                      type='text'
                      readOnly
                      value={antpsicPlabEsp}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicAfam'>
                    ¿Dispone de apoyo para el tratamiento?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicAfam'
                        name='antpsicAfam'
                        readOnly
                        value={antpsicAfam}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='apoy-fam'>Apoyo de familiares</option>
                        <option value='apoy-amig'>Apoyo de amigos</option>
                        <option value='apoy-fam-amig'>Apoyo de familiares y amigos</option>
                        <option value='no-apoy'>No dispone de ningún apoyo</option>
                        <option value='si'>Si</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              <h3>Situación laboral</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antpsicEduc'>Educación</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicEduc'
                        name='antpsicEduc'
                        readOnly
                        value={antpsicEduc}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='analf'>Analfabeto</option>
                        <option value='est-basic'>Estudios básicos</option>
                        <option value='egb-eso'>EGB/ESO</option>
                        <option value='bup-cou'>BUP/COU</option>
                        <option value='fp'>FP</option>
                        <option value='diplom'>Diplomatura</option>
                        <option value='licenc'>Licenciatura</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicExptrabaj'>
                    Expectativa de trabajo
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicExptrabaj'
                        name='antpsicExptrabaj'
                        readOnly
                        value={antpsicExptrabaj}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='sin-expt'>Sin expectativas</option>
                        <option value='mant-trabj-act'>
                          Mantener su trabajo actual
                        </option>
                        <option value='camb-trabj'>Cambiar de trabajo</option>
                        <option value='comenz-trabj'>
                          Comenzar a trabajar
                        </option>
                        <option value='perm-baja'>
                          Permanecer de baja
                        </option>
                        <option value='otros'>
                          Otros
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicTrabaj'>Trabaja</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicTrabaj'
                        name='antpsicTrabaj'
                        readOnly
                        value={antpsicTrabaj}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='cuent-ajen'>Por cuenta ajena</option>
                        <option value='neg-prop'>Negocio propio</option>
                        <option value='neg-fam'>Negocio familiar</option>
                        <option value='no-trabj'>No tiene trabajo</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='antpsicEstlabact'>
                    Estado laboral actual
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicEstlabact'
                        name='antpsicEstlabact'
                        readOnly
                        value={antpsicEstlabact}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='fijo'>Fijo</option>
                        <option value='temporal'>Temporal</option>
                        <option value='en-paro'>En paro</option>
                        <option value='baja-incapac'>
                          De baja/incapacidad
                        </option>
                        <option value='estudiante'>Estudiante</option>
                        <option value='ama-casa'>Ama de casa</option>
                        <option value='jubilado'>Jubilado</option>
                        <option value='otros'>Otros</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div className='field key' data-key={antpsicProfRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Tiene alguna profesión u oficio?
                    </label>
                    <label className='radio' htmlFor='antpsicProfRadSi'>
                      <input
                        id='antpsicProfRadSi'
                        name='antpsicProfRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicProfRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicProfRadNo'>
                      <input
                        id='antpsicProfRadNo'
                        name='antpsicProfRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicProfRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicProfEsp'>Especificar oficio</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicProfEsp'
                      type='text'
                      readOnly
                      value={antpsicProfEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicManutRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Contribuye alguien en su manutención?
                    </label>
                    <label className='radio' htmlFor='antpsicManutRadSi'>
                      <input
                        id='antpsicManutRadSi'
                        name='antpsicManutRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicManutRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicManutRadNo'>
                      <input
                        id='antpsicManutRadNo'
                        name='antpsicManutRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicManutRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicManutEsp'>
                    Especificar manutención
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicManutEsp'
                      type='text'
                      readOnly
                      value={antpsicManutEsp}
                    />
                  </div>
                </div>
              </div>
              <h3>Situación legal</h3>
              <div className='grid--2col'>
                <div
                  className='field key'
                  data-key={antpsicTrafdrogRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha traficado con drogas?
                    </label>
                    <label className='radio' htmlFor='antpsicTrafdrogRadSi'>
                      <input
                        id='antpsicTrafdrogRadSi'
                        name='antpsicTrafdrogRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicTrafdrogRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicTrafdrogRadNo'>
                      <input
                        id='antpsicTrafdrogRadNo'
                        name='antpsicTrafdrogRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicTrafdrogRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicTrafdorgEsp'>
                    Especificar tráfico
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicTrafdorgEsp'
                      type='text'
                      readOnly
                      value={antpsicTrafdorgEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicJuicRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Está actualmente esperando juicio o sentencia?
                    </label>
                    <label className='radio' htmlFor='antpsicJuicRadSi'>
                      <input
                        id='antpsicJuicRadSi'
                        name='antpsicJuicRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicJuicRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicJuicRadNo'>
                      <input
                        id='antpsicJuicRadNo'
                        name='antpsicJuicRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicJuicRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicJuicEsp'>Especificar sentencia</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicJuicEsp'
                      type='text'
                      readOnly
                      value={antpsicJuicEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicCarcRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha estado alguna vez en la cárcel?
                    </label>
                    <label className='radio' htmlFor='antpsicCarcRadSi'>
                      <input
                        id='antpsicCarcRadSi'
                        name='antpsicCarcRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicCarcRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicCarcRadNo'>
                      <input
                        id='antpsicCarcRadNo'
                        name='antpsicCarcRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicCarcRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicCarcEsp'>Especificar cárcel</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicCarcEsp'
                      type='text'
                      readOnly
                      value={antpsicCarcEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicArrestRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha sido arrestado y/o acusado alguna vez?
                    </label>
                    <label className='radio' htmlFor='antpsicArrestRadSi'>
                      <input
                        id='antpsicArrestRadSi'
                        name='antpsicArrestRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicArrestRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicArrestRadNo'>
                      <input
                        id='antpsicArrestRadNo'
                        name='antpsicArrestRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicArrestRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicArrestEsp'>Especificar arresto</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicArrestEsp'
                      type='text'
                      readOnly
                      value={antpsicArrestEsp}
                    />
                  </div>
                </div>
              </div>
              <h3>Antecedentes psiquiátricos</h3>
              <div className='grid--2col'>
                <div className='field key' data-key={antpsicSuicRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Intentos suicidas</label>
                    <label className='radio' htmlFor='antpsicSuicRadSi'>
                      <input
                        id='antpsicSuicRadSi'
                        name='antpsicSuicRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicSuicRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicSuicRadNo'>
                      <input
                        id='antpsicSuicRadNo'
                        name='antpsicSuicRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicSuicRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicSuicEsp'>
                    Especificar intentos suicidas
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicSuicEsp'
                      type='text'
                      readOnly
                      value={antpsicSuicEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicAlucRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Alucinaciones</label>
                    <label className='radio' htmlFor='antpsicAlucRadSi'>
                      <input
                        id='antpsicAlucRadSi'
                        name='antpsicAlucRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicAlucRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicAlucRadNo'>
                      <input
                        id='antpsicAlucRadNo'
                        name='antpsicAlucRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicAlucRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicAlucEsp'>
                    Especificar alucinaciones
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicAlucEsp'
                      type='text'
                      readOnly
                      value={antpsicAlucEsp}
                    />
                  </div>
                </div>
                <div className='field key' data-key={antpsicApanRad?.toString()}>
                  <div className='control'>
                    <label className='radio-title'>Ataques de pánico</label>
                    <label className='radio' htmlFor='antpsicApanRadSi'>
                      <input
                        id='antpsicApanRadSi'
                        name='antpsicApanRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicApanRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicApanRadNo'>
                      <input
                        id='antpsicApanRadNo'
                        name='antpsicApanRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicApanRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicApanEsp'>
                    Especificar ataques de pánico
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicApanEsp'
                      type='text'
                      readOnly
                      value={antpsicApanEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicConvulRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Convulsiones</label>
                    <label className='radio' htmlFor='antpsicConvulRadSi'>
                      <input
                        id='antpsicConvulRadSi'
                        name='antpsicConvulRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicConvulRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicConvulRadNo'>
                      <input
                        id='antpsicConvulRadNo'
                        name='antpsicConvulRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicConvulRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicConvulEsp'>
                    Especificar convulsiones
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicConvulEsp'
                      type='text'
                      readOnly
                      value={antpsicConvulEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicPerdconcRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      Pérdidas de conciencia
                    </label>
                    <label className='radio' htmlFor='antpsicPerdconcRadSi'>
                      <input
                        id='antpsicPerdconcRadSi'
                        name='antpsicPerdconcRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPerdconcRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPerdconcRadNo'>
                      <input
                        id='antpsicPerdconcRadNo'
                        name='antpsicPerdconcRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPerdconcRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPerdconcEsp'>
                    Especificar pérdidas de conciencia
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPerdconcEsp'
                      type='text'
                      readOnly
                      value={antpsicPerdconcEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicAmnlacRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Amnesia lacunar</label>
                    <label className='radio' htmlFor='antpsicAmnlacRadSi'>
                      <input
                        id='antpsicAmnlacRadSi'
                        name='antpsicAmnlacRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicAmnlacRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicAmnlacRadNo'>
                      <input
                        id='antpsicAmnlacRadNo'
                        name='antpsicAmnlacRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicAmnlacRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicAmnlacEsp'>
                    Especificar amnesia lacunar
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicAmnlacEsp'
                      type='text'
                      readOnly
                      value={antpsicAmnlacEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicPensparanRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>Pensamiento paranoide</label>
                    <label className='radio' htmlFor='antpsicPensparanRadSi'>
                      <input
                        id='antpsicPensparanRadSi'
                        name='antpsicPensparanRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicPensparanRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicPensparanRadNo'>
                      <input
                        id='antpsicPensparanRadNo'
                        name='antpsicPensparanRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicPensparanRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicPensparanEsp'>
                    Especificar pensamiento paranoide
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicPensparanEsp'
                      type='text'
                      readOnly
                      value={antpsicPensparanEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicTratpsicofRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Tiene o ha tenido prescrito tratamiento
                      psicofarmacológico independiente a la adicción?
                    </label>
                    <label className='radio' htmlFor='antpsicTratpsicofRadSi'>
                      <input
                        id='antpsicTratpsicofRadSi'
                        name='antpsicTratpsicofRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicTratpsicofRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicTratpsicofRadNo'>
                      <input
                        id='antpsicTratpsicofRadNo'
                        name='antpsicTratpsicofRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicTratpsicofRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicTratpsicofEsp'>
                    Especificar tratamiento psicofarmacológico
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicTratpsicofEsp'
                      type='text'
                      readOnly
                      value={antpsicTratpsicofEsp}
                    />
                  </div>
                </div>
                <div
                  className='field key'
                  data-key={antpsicTratpsiqRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      ¿Ha estado bajo tratamiento psiquiátrico alguna vez
                      independiente a la adicción?
                    </label>
                    <label className='radio' htmlFor='antpsicTratpsiqRadSi'>
                      <input
                        id='antpsicTratpsiqRadSi'
                        name='antpsicTratpsiqRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicTratpsiqRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicTratpsiqRadNo'>
                      <input
                        id='antpsicTratpsiqRadNo'
                        name='antpsicTratpsiqRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicTratpsiqRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>

                <div className='field lock'>
                  <label htmlFor='antpsicTratpsiqEsp'>
                    Especificar tratamiento psiquiátrico
                  </label>
                  <div className='control'>
                    <input
                      className='input'
                      id='antpsicTratpsiqEsp'
                      type='text'
                      readOnly
                      value={antpsicTratpsiqEsp}
                    />
                  </div>
                </div>
              </div>
              <h3>Valoración del terapeuta</h3>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='antpsicTerapdist' className='radio-title'>
                    ¿La anterior información está significativamente
                    distorsionada?
                  </label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        required
                        className='select'
                        id='antpsicTerapdist'
                        name='antpsicTerapdist'
                        readOnly
                        value={antpsicTerapdist}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='no'>No</option>
                        <option value='si-falsa'>
                          Sí, por falsa declaración del paciente
                        </option>
                        <option value='si-incap'>
                          Sí, por incapacidad de comprensión del paciente
                        </option>
                        <option value='si-efect'>
                          Sí, por estar bajo los efectos del consumo
                        </option>
                        <option value='si'>Sí</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div
                  className='field key'
                  data-key={antpsicTerapcolabRad?.toString()}
                >
                  <div className='control'>
                    <label className='radio-title'>
                      Durante la entrevista ¿el paciente ha estado colaborador?
                    </label>
                    <label className='radio' htmlFor='antpsicTerapcolabRadSi'>
                      <input
                        id='antpsicTerapcolabRadSi'
                        name='antpsicTerapcolabRad'
                        type='radio'
                        value='Si'
                        readOnly
                        checked={antpsicTerapcolabRad === "Si"}
                      />
                      Si
                    </label>
                    <label className='radio' htmlFor='antpsicTerapcolabRadNo'>
                      <input
                        id='antpsicTerapcolabRadNo'
                        name='antpsicTerapcolabRad'
                        type='radio'
                        value='No'
                        readOnly
                        checked={antpsicTerapcolabRad === "No"}
                      />
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className='field'>
                <label className='label-title' htmlFor='antpsicAnamnesis'>
                  Anamnesis
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='antpsicAnamnesis'
                    id='antpsicAnamnesis'
                    readOnly
                    value={antpsicAnamnesis}
                  ></textarea>
                </div>
              </div>
              <div className='field'>
                <label className='label-title' htmlFor='antpsicEntfamiliar'>
                  Entrevista familiar
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='antpsicEntfamiliar'
                    id='antpsicEntfamiliar'
                    readOnly
                    value={antpsicEntfamiliar}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        ))}
      </div>
      {!errorMessage &&
      <div id='actions'>
      {((diffDate <= 72 && props.userRole.includes('psicologia')) || (props.userRole.includes('administrador')))  &&
        <Link className='button is-link' to={`edit`}>
          Editar
        </Link>
      }
      </div>
      }
    </>
  );
}
